// This is just an example,
// so you can safely delete all default props below

export default {
  subscribe_to: "Suscríbete a",
  company_detail: "Información de la empresa/autónomo",
  Purchase: "Compra",
  try_before_you_buy: "Prueba antes de comprar",
  rental: "Alquiler",
  rent: "Alquilar",
  per: "Al",
  powered_by: "Powered by",
  individual: "Particular",
  company: "Empresa",
  name: "Nombre",
  first_name: "Nombre",
  last_name: "Apellido",
  nif: "NIF",
  company_name: "Nombre de empresa",
  mobile: "Móvil",
  representative_name: "Nombre del representante",
  email: "Correo electrónico",
  delivery_address: "Dirección de entrega",
  address_line: "Primera línea de dirección ",
  street_name: "Segunda linea",
  country: "País",
  select_country: "Seleccionar país",
  used_saved_address: "Dirección guardada usada",
  shipping_details: "Detalles de envío",
  city: "Ciudad",
  zip: "Código postal",
  state: "Estado/Provincia",
  select_state: "Seleccionar estado/provincia",
  vat: "Número de identificación fiscal / NIF",
  vat: "CIF/NIF",
  use_for_billing_address: "Utilizar una dirección de facturación diferente",
  add_billing_address: "Añadir dirección de facturación",
  billing_address: "Dirección de Facturación",
  next: "Continuar",
  pay: "Pagar",
  enter_payment_details: "Completa los detalles de pago",
  back: "Volver",
  card: "Tarjeta",
  bank_account: "Cuenta bancaria",
  name_on_card: "Nombre en la tarjeta",
  bank_detail: "Detalle bancario",
  account_holder_name: "Nombre del titular de la cuenta",
  account_number: "Número de cuenta",
  account: "Cuenta",
  select_account_type: "Seleccionar tipo de cuenta",
  routing_number: "Número de ruta",
  select_currency: "Seleccione el tipo de moneda",
  currency: "Divisa",
  confirmation_paragraph1: "Al confirmar su pedido, permite que",
  confirmation_paragraph2:
    " se realizen cargos en su tarjeta por este importe y futuros pagos de acuerdo con sus términos y condiciones. Puedes cancelar el contrato después de la duración mínima seleccionada.",
  day: " Día",
  days: " Días",
  month: " Mes",
  months: " Meses", 
  years: "Años",
  // Unit options for dropdowns  
  Months: "Meses",
  Years: "Años",
  you_will_pay: "Hoy pagas",
  billed_monthly: "Facturado mensualmente",
  thanks_for_request: "Gracias por tu pedido",
  rental_option_desc:
    "Nos encanta que hayas elegido nuestra opción de alquiler, sabemos que es el futuro.",
  receive_info:
    "Gracias por alquilar con nosotros. En breve recibirás un correo de confirmación",
  verification_1:
    "Necesitamos que verificar tu identidad para que podamos asegurarnos de que es una persona real. Solo lo tendrás que hacer una vez y ya podrás utilizar sharpei en todas las webs.",
  verification_2: "Ten listo tu carnet de identidad",
  verification_3:
    "Necesitaremos verificar tu identificación, así que antes de comenzar la verificación asegúrate de tener la identificación a mano.",
  verification_4: "Tendrás que hacerte un selfie",
  verification_5:
    "Necesitaremos que estés en un lugar con buena luz para que podamos verificar tu identidad a través de un selfie.",
  verification_6: "Aprobación de verificación",
  verification_7:
    "Podemos tardar hasta 24 horas en aprobar su verificación, ya que un miembro del equipo verificará manualmente la información.",
  verification_8: "Debe estar verificado para que su solicitud sea aceptada.",
  back_to_sharpei: "Volver al sitio web",
  verify_self: "Necesitas verificarte para ",
  proceed_with_order: "continuar con el pedido",
  verification_done: "Verificación Completada",
  thank_verified:
    "Gracias por su verificación, la revisaremos en las próximas horas y nos pondremos en contacto.",
  return: "Atrás",
  purchase_option: "Opción de compra",
  delivery_in_days: "Entrega en 3–7 días hábiles",
  after: "Pasado",
  after_months: "puedes devolver el producto,",
  increase_payment: "quedartelo o ampliar el periodo segun tus necesidades",
  sent_info:
    "Le enviaremos un correo donde le indicaremos si su solicitud ha sido aceptada o denegada. En caso de aceptación encontrará toda la información en el correo electrónico.",
  for: "durante",
  every: "Pago cada ",
  months: " meses",
  monthly_payment: "Mensualidad",
  single_payment: "Pago único",
  verify_identity: "Verifica tu",
  identity: "Identidad",
  verification: "Verificación",
  verify_my_identity: "Verificar mi identidad",
  start: "Iniciar verificación de identidad",
  something_wrong: "Algo salió mal. Inténtalo de nuevo",
  company_information: "Información de la empresa",
  invalid_phone: "Teléfono no válido",
  enter_phone: "Por favor ingresa tu teléfono",
  enter_valid_phone: "Por favor introduce un teléfono válido",
  enter_email: "Por favor introduzca su correo electrónico",
  country_code: "Código de país",
  phone_number: "Número de teléfono",
  subscription: "Suscripción",
  buyback: "Seguro de recompra",
  user_information: "Informacion del cliente",
  shipping: "Envío",
  payment: "Pago",
  payment_details: "Detalles del pago",
  used_saved_card: "Tarjeta guardada usada",
  card_number: "Número de tarjeta",
  expiration: "Vencimiento",
  cvc: "CVC",
  save_this_card: "Guarde esta tarjeta",
  continue: "Continuar",
  billing: "Facturación",
  billing_details: "Detalles de facturación",
  verify_message_1:
    "Necesitamos verificar su identidad para que este pedido sea aceptado.",
  verify_message_2:
    "Una vez que hayas verificado una vez, no tendrás que volver a hacerlo.",
  order_summary: "Resumen del pedido",
  total_without_tax: "Total sin impuestos",
  tax: "Impuesto",
  total: "Total",
  free: "Gratis",
  pay_now: "Pagar ahora",
  final_step_desc:
    "Este es el paso final, después de tocar el botón Pagar ahora, el pago será una transacción.",
  any_doubts: "¿Tienes dudas sobre el alquiler?",
  any_doubts_for_mobile: "¿Alguna duda sobre el alquiler?",
  how_works: "Cómo funciona",
  return_item:
    "Pasado este tiempo podrás elegir si devolver el producto o pagar la diferencia para comprarlo.",
  previous: "Previo",
  accept:
    "Acepto que mis datos sean tratados por Sharpei y puedan ser reutilizados para otras empresas asociadas, para fines operacionales y no comerciales. De acuerdo con su ",
  terms_conditions: "Términos y condiciones",
  and: "y",
  privacy_policy: "Política de Privacidad",
  as_well: "Así como la",
  of: "de",
  zero_tax: "0,00",
  street_warning:
    "Es necesario añadir el número de la calle para que se detecte automáticamente.",
  sub_total: "Subtotal",
  tax_included: "Impuesto incluido",
  description: "Descripción",
  choose_date:
    "Todos los envíos se mandan lo antes posible. Si quieres que lo enviemos más adelante por favor especifica la fecha. ",
  continue_shopping: "Continuar comprando",
  please_wait: "Enhorabuena tu renting ha sido pre-aprobado, le estamos redirigiendo a la página del banco para completar la firma del contrato",
  payment_not_supported: "Método de pago no admitido",
  not_qualify: "Gracias por su solicitud de financiación. Su solicitud está actualmente en revisión. Un miembro de nuestro equipo se pondrá en contacto con usted en 2-3 días hábiles con nuestra decisión.",
  grenke_privacy_policy:
    "Al utilizar este servicio, será redirigido fuera del dominio de Sharpei a un portal externo. Los datos introducidos serán tratados exclusivamente con la finalidad de evaluar la posibilidad de celebrar un contrato, de acuerdo con la política de privacidad de GRENKE.",
  grenke_privacy_policy_2:
    "Los datos no serán cedidos a terceros, salvo obligación legal, aunque GRENKE podrá confiar en encargados del tratamiento de datos como B2F, Docusign y Sharpei.",
  learn_more: "Más información",
  grenke_privacy_policy_3: `Cualquier dato personal introducido en el formulario será tratado de acuerdo con la política de privacidad de GRENKE. Los datos personales serán tratados únicamente con la finalidad de evaluar la posibilidad de celebrar un contrato, legitimado por la necesaria ejecución contractual o precontractual entre las partes.`,
  grenke_privacy_policy_4:
    "GRENKE no cederá los datos a terceros, salvo obligación legal. No obstante, podrá recurrir a encargados del tratamiento de datos, como B2F, Docusign y Sharpei, exclusivamente para las finalidades antes mencionadas.",
  grenke_privacy_policy_5:
    "Puede ejercitar los derechos reconocidos por la legislación vigente en materia de protección de datos, como acceso, rectificación, supresión, limitación, oposición o portabilidad, dirigiéndose por escrito a dataprotectionGR@grenke.es.",
  renting: "Renting",
  insurance_desc:
    "El renting te ofrece la flexibilidad de utilizar el equipo que necesitas sin el coste inicial de la compra. Con nuestros planes, disfrutas de un contrato que incluye seguro para tu tranquilidad. El período mínimo de compromiso se ajusta a la duración que hayas seleccionado, haciéndolo sencillo y conveniente.",
  advantages: "Ventajas",
  fully_comprehensive: "Seguro a todo riesgo",
  vat_deduct: "100% IVA deducible",
  benefits: "Liquidez y ahorro fiscal",
  amount_price:
    "Los importes se expresan sin IVA. El seguro a todo riesgo está incluido, y su coste se mostrará en la etapa final del contrato.",
  more_information: "Para más información",
  click_here: "haga clic aquí",
  grenke_consent:
    "He leído y acepto que mis datos sean tratados siguiendo lapolítica de privacidad de SHARPEI y GRENKE",
  grenke_self_employed_message:
    "Para autónomos, el renting está disponible hasta 24 meses. Los precios son orientativos y podrían ajustarse en operaciones a partir de 5.000 €.",
  grenke_company_message:
    "Los precios son orientativos y podrían ajustarse en operaciones a partir de 10.000 €.",
  view_policy: 'Ver política',
  // Grenke document upload page
  grenke_document_upload_title: "Carga de Documentos Requerida",
  grenke_document_upload_subtitle: "Por favor, suba los documentos requeridos para completar su solicitud.",
  grenke_financing_details: "Detalles de Financiación",
  grenke_monthly_payment: "Pago Mensual",
  grenke_duration: "Duración",
  grenke_months: "meses",
  grenke_initial_payment: "Pago Inicial",
  grenke_required_documents: "Documentos Requeridos",
  grenke_upload_description: "Por favor, suba los siguientes documentos para proceder con su solicitud.",
  grenke_max_file_size: "Tamaño máximo de archivo: 10MB",
  optional: "Opcional",
  upload_success: "Carga Exitosa",
  document_uploaded_successfully: "Documento '{doc}' cargado exitosamente",
  upload_error: "Error de Carga",
  document_upload_failed: "Error al cargar el documento '{doc}'. Por favor, inténtelo de nuevo.",
  remove: "Eliminar",
  submit_documents: "Enviar Documentos",
  missing_documents: "Documentos Faltantes",
  please_upload_all_required_documents: "Por favor, suba todos los documentos requeridos antes de enviar.",
  submission_success: "Envío Exitoso",
  all_documents_submitted_successfully: "Todos los documentos han sido enviados exitosamente.",
  submission_error: "Error de Envío",
  failed_to_submit_documents: "Error al enviar documentos. Por favor, inténtelo de nuevo.",
  missing_request_token: "Falta el token de solicitud. Por favor, inténtelo de nuevo.",
  uploading: "Subiendo",
  loading_documents: "Cargando documentos",
  // Grenke installment summary
  grenke_application_approved: "Solicitud Aprobada",
  grenke_installment_approved_message: "Su solicitud de financiación Grenke ha sido aprobada. Por favor, revise su plan de cuotas a continuación.",
  grenke_month: "mes",
  grenke_request_info: "Información de la Solicitud",
  grenke_request_status: "Estado de la Solicitud",
  grenke_financing_id: "ID de Financiación",
  continue_to_document_upload: "Continuar a Carga de Documentos",
  how_data_process: "¿Cómo serán tratados mis datos?",
  summary_of_application: "Resumen de tu solicitud",
  discount: "Descuento",
  monthly_rent: "Pago mensual",
  extras_single_payment: "Extras - Pago único",
  insurance_single_payment: "Seguro - Pago único",
  taxes: "Impuestos",
  total_with_insurance: "Coste incial con seguro anual",
  transaction_over_price_limit: "Gracias por su solicitud",
  transaction_over_price_limit_message:
    "El importe de su solicitud supera el límite de crédito que se puede procesar online. Nos pondremos en contacto con usted para finalizar su solicitud.",
  transaction_under_price_limit_message:
    "Gracias por su solicitud El importe de su solicitud no llega a límite de crédito que se puede procesar online de 500€.",
  unknown_error: "Error desconocido",
  try_again_later: "Por favor, inténtelo de nuevo más tarde.",
  preappoval_not_accepted: "Solicitud en Revisión",
  wrong_zip_code: "Código postal incorrecto",
  enter_valid_zip_code: "Por favor, introduzca un código postal válido",
  invalid_us_zip: "Por favor, ingrese un código postal válido de EE.UU.",
  zip_state_mismatch: "El código postal no coincide con el estado seleccionado",
  income_warning_too_low: "Esto parece bajo. El salario mínimo de EE.UU. es ~$1,250/mes. Por favor verifique que sea correcto.",
  income_warning_too_high: "Este ingreso mensual parece muy alto. Por favor verifique que sea correcto.",
  net_income_warning_too_low: "Este salario neto parece bajo. Por favor verifique que sea correcto.",
  net_income_exceeds_gross: "El salario neto no puede ser mayor que el ingreso bruto.",
  income_ratio_warning_low_tax: "Su tasa impositiva parece muy baja. Las tasas típicas son 15-35%. Por favor verifique ambos montos.",
  income_ratio_warning_high_tax: "Su tasa impositiva parece muy alta. Las tasas típicas son 15-35%. Por favor verifique ambos montos.",
  enter_valid_fiscal_code: "Por favor, introduzca un número de IVA válido",
  wrong_fiscal_code: "Número de IVA incorrecto",
  grenke_individual_nif_warning: "Este servicio es solo para empresas y autónomos. Si no eres un autónomo no se te aceptará la operación",
  important: "Importante",
  confirm_autonomo: "Confirmación",
  nif_detected_confirm: "Has insertado un DNI. Por favor, confirma que eres autónomo.",
  yes_im_autonomo: "Sí, soy autónomo",
  no_im_not_autonomo: "No, no soy autónomo",
  grenke_service_not_for_individuals: "Este servicio no aplica a particulares",
  grenke_payment_method: "Metodo de pago de GRENKE",
  purchase_option: "Opción de compra al final del renting.",
  info_about_renting: "Info sobre el renting",
  verify_message_1:
    "Necesitamos verificar su identidad para que este pedido sea aceptado.",
  verify_message_2:
    "Una vez que hayas verificado una vez, no tendrás que volver a hacerlo.",
  verification_1:
    "Necesitamos que verificar tu identidad para que podamos asegurarnos de que es una persona real. Solo lo tendrás que hacer una vez y ya podrás utilizar sharpei en todas las webs.",
  verification_2: "Ten listo tu carnet de identidad",
  verification_3:
    "Necesitaremos verificar tu identificación, así que antes de comenzar la verificación asegúrate de tener la identificación a mano.",
  verification_4: "Tendrás que hacerte un selfie",
  verification_5:
    "Necesitaremos que estés en un lugar con buena luz para que podamos verificar tu identidad a través de un selfie.",
  verification_6: "Aprobación de verificación",
  verification_7:
    "Podemos tardar hasta 24 horas en aprobar su verificación, ya que un miembro del equipo verificará manualmente la información.",
  verification_8: "Debe estar verificado para que su solicitud sea aceptada.",
  "Equip your company in one click": "Equipa tu empresa en un clic",
  "Equip your business":
    "Equipa tu negocio sin comprometer tu liquidez y paga cómodamente en cuotas fijas mensuales.",
  "Only for companies and self-employed": "Sólo para empresas y autónomos",
  "How does it work": "¿Cómo funciona?",
  "Choose the products": "Elige lo/s producto/s",
  "Choose the products you want to rent":
    "Elige lo/s producto/s que quieres alquilar.",
  "Select the term and fee": "Selecciona el plazo y la cuota",
  "Select the terms that best suits you":
    "Entre 12 y 48 meses, selecciona el plazo que mejor se adapte a tus necesidades.",
  "Perform online verification": "Realiza la verificación online",
  "Complete the information":
    "Completa tus datos, firma el contrato online y espera el email con la aprobación.",
  "Receive your products": "Recibe tus productos",
  "Enjoy products":
    "Recibe tus productos y disfrutalos el tiempo que los hayas contratado.",
  "Return it, buy it or extend your contract":
    "Devuélvelo, cómpralo o extiende tu contrato",
  "When contract ends":
    "Cuando termine el contrato podrás elegir que hacer, si devuelves el producto, si lo compras o si prorrogas tu contrato",
  "Welcome to the circular economy": "¡Bienvenido a la economía circular!",
  "Good for you, good for the planet": "Bueno para ti, bueno para el planeta.",
  application_submitted: "La solicitud se ha procesado correctamente",
  request_processed: "La solicitud ha sido procesada correctamente,",
  receive_email_shortly:
    "Deberías recibir un correo electrónico con más información sobre el pedido en breve.",
  return_to_portal: "Seguir comprando",
  email_required: "El correo electrónico es obligatorio.",
  name_require: "El nombre es obligatorio.",
  company_name_required: "El nombre de la empresa es obligatorio.",
  address_required: "La dirección es obligatoria.",
  city_required: "La ciudad es obligatoria.",
  state_required: "El estado es obligatorio.",
  country_required: "El país es obligatorio.",
  zip_required: "El código postal es obligatorio.",
  billing: "Facturación",
  enter_address: "Ingrese su dirección",
  enter_phone_number: "Ingrese un número de teléfono",
  phone_number_required: "El número de teléfono es obligatorio",
  invalid_phone: "Número de teléfono no válido",
  first_name_required: "El nombre es obligatorio",
  last_name_required: "El apellido es obligatorio",
  nif_required: "El NIF es obligatorio",
  representative_name_required: "El nombre del representante es obligatorio",
  representative_name_two_surnames_required: "El nombre del representante debe incluir nombre y dos apellidos (formato: Nombre Apellido1 Apellido2)",
  submit: "Enviar",
  stripe_payment_method: "Método de pago de franjas",
  invalid_email: "Correo electrónico no válido",
  valid_nif: "NIF debe tener 9 caracteres alfanumericos",
  calculating: "Calculando",
  user_detail: "Información del cliente",
  "Select the terms that best suits you b2c":
  "Selecciona el plazo que mejor se adapte a tus necesidades.",
"Complete the information b2c":
  "Completa tus datos y verifica tu identidad al finalizar el pedido.",
"Information for companies/self-employed workers":
  " Info para empresas/autónomos",
    "Get equipped comfortably" : "Equipate pagando cómodamente tus cuotas fijas mensuales.",
  "Get your product in one click": "Ten tu producto en un click",
  enter_first_name: "Ingrese su nombre",
  enter_last_name: "Ingrese su apellido",
  enter_email: "Ingrese su correo electrónico",
  enter_phone_number: "Ingrese su número de teléfono",
  enter_address: "Ingrese su dirección",
  enter_city: "Ingrese su ciudad",
  enter_state: "Ingrese su estado/provincia",
  enter_zip: "Ingrese su código postal",
  back_to_product: "Volver al producto",
  select_customer_type: "Seleccionar tipo de cliente",
  duration: "Duración",
  finalized_offer_terms: "Términos finalizados de la oferta",
  quantity: "Cantidad",
  leasing_total: "Total del renting",
  purchase_option_at_end_of_lease: "Opción de compra al final del renting",
  consumables: "Consumibles",
  monthly_lease: "Renting mensual",
  first_month: "Primer Mes",
  monthly_financing: "Financiación mensual",
  enter_discount_code: "Ingrese código de descuento",
  apply: "Aplicar",
  enter_contact_person_name: "Ingrese el nombre del representante",
  enter_tax_id_vat_number: "Ingrese el número de identificación fiscal / NIF",
  invalid_spanish_tax_id: "Formato de NIF/CIF/NIE español inválido",
  spanish_tax_id_9_chars: "El NIF/CIF/NIE debe tener 9 caracteres",
  invalid_spanish_tax_id_format: "Formato inválido. Debe ser: CIF (Letra+7dígitos+Letra/Dígito), NIF (8dígitos+Letra), o NIE (X/Y/Z+7dígitos+Letra)",
  standard_sharpei_terms: "Se aplican los Términos y Condiciones estándar de Sharpei a esta compra. Al utilizar nuestra plataforma, acepta estos términos.",
  terms_govern_use: "Estos términos y condiciones rigen su uso de la plataforma Sharpei y sus servicios.",
  terms_acknowledgment: "Al continuar utilizando los servicios de Sharpei, reconoce que ha leído, comprendido y aceptado estos términos.",
  privacy_policy_description: "La Política de Privacidad de Sharpei describe cómo recopilamos y utilizamos su información personal a través de nuestra plataforma.",
  privacy_commitment: "Nos comprometemos a proteger su privacidad y garantizar la seguridad de su información personal.",
  privacy_policy_explanation: "Esta política explica cómo recopilamos, utilizamos y divulgamos su información cuando utiliza nuestra plataforma.",
  standard_purchase: "Se aplican los Términos y Condiciones estándar a su compra de,",
  terms_purchase: "Al continuar con su compra, acepta cumplir con estos términos y condiciones.",
  standard_privacy: "Se aplica la Política de Privacidad Estándar a su información personal recopilada por ",
  your_privacy: "Su privacidad es importante para nosotros. Esta política describe cómo recopilamos y procesamos su información personal.",
  the_merchant: "el comerciante",
  powered_by_sharpei: "Desarrollado por Sharpei",
  mo: 'mes',
  add: "Añadir",
  delivery: "Entrega",
  consumables_total: "Total de consumibles",
  includes_all_services: "Incluye alquiler de dispositivo y todas las suscripciones",

  // Financing related translations
  additional_information: "Additional Information",
  ssn: "Social Security Number",
  date_of_birth: "Date of Birth",
  pay_frequency: "Pay Frequency",
  select_pay_frequency: "Select pay frequency",
  gross_income: "Gross Income",
  net_income: "Net Income",
  last_pay_day: "Last Pay Day",
  next_pay_day: "Next Pay Day",
  sharpei_privacy_policy: "Sharpei Privacy Policy",
  grenke_privacy_policy_header: "Grenke Privacy Policy",
  enter_company_name: "Introduce el nombre de la empresa",
  business_type: "Tipo de Negocio",
  select_business_type: "Selecciona tu tipo de negocio",
  autonomo: "Autónomo / Trabajador Autónomo",
  empresa: "Empresa / Sociedad Registrada",
  your_full_name: "Tu Nombre Completo",
  authorized_contact_person: "Persona de Contacto Autorizada",
  
  // Grenke eligibility requirements
  grenke_b2b_only: "Este servicio es solo para empresas y autónomos.",
  grenke_autonomo_requirements_title: "Requisitos para Autónomos:",
  grenke_autonomo_min_years: "Mínimo 3 años de antigüedad como autónomo",
  grenke_autonomo_max_term: "Plazo máximo: 24 meses (operaciones estándar)",
  grenke_autonomo_extended_term: "Hasta 60 meses disponible para operaciones > 5.000€ o en Canarias",
  grenke_empresa_requirements_title: "Requisitos para Empresas:",
  grenke_empresa_min_years: "Mínimo 1 año completo de operación",
  grenke_empresa_max_term: "Plazo máximo: 60 meses",
  
  // Business establishment date
  fecha_de_alta: "Fecha de Alta",
  fecha_de_alta_placeholder: "Selecciona la fecha",
  fecha_de_alta_required: "La fecha de alta es obligatoria",
  fecha_de_alta_invalid: "Fecha inválida",
  autonomo_min_3_years: "Los autónomos deben tener mínimo 3 años de antigüedad",
  empresa_min_1_year: "Las empresas deben tener mínimo 1 año de operación",
  fecha_de_alta_help: "Fecha en que iniciaste tu actividad como autónomo o empresa",
  fecha_cannot_be_future: "La fecha no puede ser en el futuro",
  autonomo_must_use_nif_nie: "Los autónomos deben usar NIF (DNI) o NIE. Formato: 8 dígitos + letra (ej: 12345678A) o X/Y/Z + 7 dígitos + letra (ej: X1234567A)",
  empresa_must_use_cif: "Las empresas deben usar CIF. Formato: Letra + 7 dígitos + letra/dígito (ej: B12345678)",
  pay_frequency_required: "Pay frequency is required",
  invalid_pay_frequency: "Please select a valid pay frequency",
  last_pay_day_required: "Last pay day is required",
  last_pay_day_future: "Last pay day cannot be in the future",
  invalid_last_pay_day: "Invalid last pay day",
  next_pay_day_required: "Next pay day is required",
  next_pay_day_before_last: "Next pay day must be after last pay day",
  invalid_next_pay_day: "Invalid next pay day",
  ssn_required: "SSN es requerido",
  invalid_ssn: "Por favor ingrese un SSN válido de 9 dígitos",
  invalid_drivers_license: "Por favor ingrese un número de licencia de conducir válido",
  invalid_drivers_license_basic: "La licencia de conducir debe tener 4-20 caracteres alfanuméricos (solo letras y números)",
  invalid_drivers_license_fake: "Este parece ser un número de licencia falso o de prueba. Por favor ingrese un número real",
  invalid_drivers_license_format: "El formato de la licencia de conducir es inválido para el estado seleccionado",
  invalid_drivers_license_state_format: "El formato de la licencia no coincide con el formato esperado para su estado",
  invalid_passport_format: "El pasaporte de EE.UU. debe tener exactamente 9 caracteres alfanuméricos",
  invalid_state_id_format: "La identificación estatal debe tener 4-20 caracteres alfanuméricos",
  state_required_for_license: "El estado es requerido cuando se usa una licencia de conducir",
  drivers_license_predefined_note: "La Licencia de Conducir está preseleccionada ya que es actualmente la única forma de identificación aceptada",
  select_state_first: "Seleccione su estado primero",
  tooltip_state_selection: "Seleccione su estado para habilitar la validación correcta del formato de licencia",
  tooltip_select_state_first: "Por favor seleccione su estado primero para una validación adecuada",
  dob_required: "Date of birth is required",
  dob_future: "Date of birth cannot be in the future",
  invalid_dob: "Invalid date of birth",
  must_be_18_years_or_older: "Debes tener 18 años o más",
  gross_income_required: "Gross income is required",
  income_positive: "Income must be a positive number",
  invalid_gross_income: "Invalid gross income",
  net_income_required: "Net income is required",
  invalid_net_income: "Invalid net income",
  something_went_wrong: "Something went wrong. Please try again",
  generic_error: "Unknown error",
  try_again: "Please try again later.",
  // Leasing Modal Translations
  smart_equipment_leasing: "Alquiler Inteligente de Equipos",
  leasing_subtitle: "Obtén la última tecnología mientras preservas el capital con nuestras soluciones flexibles de alquiler empresarial",
  how_it_works: "Cómo funciona",
  choose_your_products: "Elige tus productos",
  choose_products_desc: "Selecciona tu producto y personalízalo con servicios opcionales o consumibles.",
  select_your_term: "Selecciona tu plazo",
  select_term_desc: "Elige un plazo de alquiler de 12 a 60 meses que se adapte a tu planificación empresarial",
  quick_approval: "Proceso de aprobación rápido",
  quick_approval_desc: "Verificación empresarial simple con aprobación rápida para empresas registradas",
  flexible_options: "Opciones flexibles al final del plazo",
  flexible_options_desc: "Al final de tu alquiler, cómpralo, actualízalo o devuélvelo - tú decides.",
  why_choose_business: "¿Por qué elegir el alquiler empresarial?",
  optimize_cash_flow: "Optimiza el flujo de caja",
  tax_efficient: "Solución eficiente fiscalmente",
  custom_payment: "Plazos de pago personalizados",
  regular_upgrades: "Actualizaciones regulares",
  reduce_reuse: "Reduce, Reutiliza, Recicla",
  circular_economy: "Hola Economía Circular",
  own_less: "Posee Menos Cosas",
  experience_more: "Experimenta Más",
  // Individual Leasing Modal
  lease_love_upgrade: "Alquílalo. Ámalo. Actualízalo.",
  individual_leasing_subtitle: "Accede a la tecnología que necesitas con pagos mensuales asequibles y total flexibilidad",
  why_choose_personal: "¿Por qué elegir el alquiler personal?",
  zero_upfront: "Sin coste inicial",
  low_monthly: "Pagos mensuales bajos",
  always_updated: "Siempre actualizado",
  no_commitment: "Sin compromiso a largo plazo",
  // Individual-specific step descriptions
  how_it_works_individual: "Cómo funciona para ti",
  choose_your_products_individual: "Elige lo que necesitas",
  choose_products_desc_individual:
    "Navega y selecciona productos que se adapten a tu estilo de vida y presupuesto.",
  select_your_term_individual: "Elige tu plazo",
  select_term_desc_individual:
    "Elige un plazo de alquiler de 12 a 60 meses que funcione con tus necesidades personales y presupuesto",
  quick_approval_individual: "Aprobación personal rápida",
  quick_approval_desc_individual:
    "Verificación de identidad simple con aprobación rápida para individuos",
  flexible_options_individual: "Opciones flexibles al final",
  flexible_options_desc_individual:
    "Cuando termine tu alquiler, cómpralo, actualiza a algo nuevo, o devuélvelo - completamente tu decisión.",
  enter_company_name: "Ingrese el nombre de la empresa",
  unit: "Unidad",
  units: "Unidades",
  application_error: "Error de Aplicación",
  processing_error: "Error de Procesamiento",
  tooltip_company_name: "Nombre legal registrado de su empresa",
  tooltip_representative_name: "Nombre completo del representante autorizado de la empresa",
  tooltip_vat: "CIF/NIF de la empresa",
  
  // US Manual Payment Integration translations (Spanish)
  us_manual_payment_integration: "Integración de Pago Manual de EE.UU.",
  ein_fed_tax_id: "EIN o ID Fiscal Federal #",
  annual_revenue: "Ingresos Anuales",
  business_owner_ssn: "Número de Seguridad Social",
  
  // Placeholders (Spanish)
  enter_ein_fed_tax_id: "Ingrese EIN o ID Fiscal Federal",
  select_annual_revenue_range: "Seleccionar rango de ingresos anuales",
  enter_business_owner_ssn: "Ingrese número de seguridad social",
  
  // Tooltips (Spanish)
  tooltip_ein_fed_tax_id: "Número de Identificación del Empleador o ID Fiscal Federal",
  tooltip_annual_revenue: "Seleccione el rango de ingresos anuales de la empresa",
  tooltip_business_owner_ssn: "Número de Seguridad Social del propietario del negocio",
  
  // Validation messages (Spanish)
  ein_fed_tax_id_required: "EIN o ID Fiscal Federal es requerido",
  annual_revenue_required: "Los ingresos anuales son requeridos",
  business_owner_ssn_required: "El número de seguridad social del propietario del negocio es requerido",
  tooltip_first_name: "Su nombre",
  tooltip_last_name: "Su apellido",
  tooltip_email: "Dirección de correo electrónico para confirmaciones de pedidos",
  tooltip_phone: "Número de teléfono con código de país",
  tooltip_street: "Dirección con número de casa/edificio",
  tooltip_city: "Nombre de la ciudad o pueblo",
  tooltip_state: "Estado, provincia o región",
  tooltip_country: "País de la dirección de envío",
  tooltip_zip: "Código postal",
  tooltip_billing_street: "Dirección de facturación",
  tooltip_billing_city: "Ciudad para la dirección de facturación",
  tooltip_billing_state: "Estado para la dirección de facturación",
  tooltip_billing_country: "País para la dirección de facturación",
  tooltip_billing_zip: "Código postal para la dirección de facturación",
  tooltip_ssn: "Número de Seguridad Social de 9 dígitos en formato XXX-XX-XXXX. Para pruebas, use: 078-05-1120, 219-09-9999, o 666-14-0500",
  tooltip_pay_frequency: "Con qué frecuencia recibe su pago",
  tooltip_gross_income: "Ingresos antes de impuestos y deducciones",
  tooltip_net_income: "Salario neto después de impuestos",
  tooltip_last_pay_day: "Fecha de tu última nómina",
  tooltip_next_pay_day: "Fecha prevista de tu próxima nómina",
  tooltip_dob_age_restriction: "Debes ser mayor de 18 años para este servicio",
  enter_billing_address: "Introduzca la dirección de facturación",
  go_back: "Volver atrás",
  continue_shopping: "Continuar comprando",
  try_different_payment: "Probar otro método de pago",
  read_only: "Solo lectura",

  // Add Spanish translations for price status indicators
  provisional_price: "Precio Provisional",
  final_price: "Precio Final",
  price_may_change_based_on_credit_check: "Este precio es provisional y puede cambiar según los resultados de tu verificación crediticia",
  price_confirmed_after_credit_check: "Este precio se ha confirmado tras tu verificación crediticia",
  price_confirmed_for_x_months: "Este precio se ha fijado para {count} pagos mensuales",
  financing_pricing_explanation: "El pago mensual mostrado es actualmente provisional. El pago mensual final se determinará una vez completada tu verificación crediticia.",
  partial_approval_message: "Su total del carrito es {invoiceAmount} y su cantidad aprobada es {approvalAmount}. ¿Está seguro de que desea pagar el monto inicial de {upfrontAmount}?",
  today: "hoy",
  
  // Mensajes de error de solicitud de financiación
  unable_to_process_application: "No Podemos Procesar Su Solicitud",
  generic_rejection_message: "Lo sentimos, pero no podemos aprobar su solicitud de financiación en este momento. Esto puede deberse a varios factores, incluyendo historial crediticio, verificación de ingresos, o criterios de préstamo actuales. No se preocupe - aún tiene otras opciones de pago disponibles para completar su compra.",
  
  // Mensajes adicionales relacionados con financiación
  financing_declined: "Solicitud de Financiación Denegada",
  financing_expired: "La Solicitud Ha Expirado",
  application_flagged: "Solicitud en Revisión",
  application_cancelled: "Solicitud Cancelada",
  no_lender_available: "No Hay Opciones de Financiación Disponibles",
  application_processing_timeout: "Estamos experimentando algunas dificultades técnicas para procesar su solicitud en este momento. Esto suele ser temporal - por favor, inténtelo de nuevo en unos minutos.",
  decline_message: "Entendemos que esto puede ser decepcionante. Nuestros socios financieros han revisado cuidadosamente su solicitud, pero no podemos ofrecer financiación en este momento. Esta decisión se basa en sus criterios de préstamo actuales y no es un reflejo de usted personalmente.",
  expired_message: "Su sesión de solicitud ha expirado por razones de seguridad. Esto suele ocurrir cuando una solicitud no se completa dentro del plazo requerido. Puede iniciar una nueva solicitud si desea intentarlo de nuevo.",
  fraud_message: "Por su seguridad y la nuestra, necesitamos revisar su solicitud con más detalle. Esta es una medida de seguridad estándar y no significa que algo esté mal. Por favor, contacte con nuestro equipo de atención al cliente y le ayudaremos a verificar su información rápidamente.",
  changemind_message: "No hay problema - su solicitud ha sido cancelada como solicitó. Siempre puede iniciar una nueva solicitud más tarde si cambia de opinión.",
  no_lender_message: "Desafortunadamente, actualmente no tenemos socios financieros disponibles para esta compra en particular. La buena noticia es que aún puede completar su pedido usando una tarjeta de crédito u otro método de pago.",
  // New keys for financing vs leasing
  financing: "Financiación",
  leasing: "Renting",
  financing_summary: "Resumen de Financiación",
  leasing_summary: "Resumen de Renting",
  purchase_option_at_end_of_financing: "Opción de compra al final del renting",
  monthly_financing: "Financiación mensual",
  info_about_financing: "Info sobre financiación",
  info_about_leasing: "Info sobre arrendamiento",
  learn_more_about_business_financing: "Más información sobre financiación empresarial",
  learn_more_about_business_leasing: "Más información sobre renting empresarial",
  fixed_term: "Plazo fijo",
  upfront_payment: "Pago inicial",
  upfront_payment_explanation: "Una vez que se apruebe su oferta de financiación, se le pedirá que haga un pago inicial. Esta es una cantidad única que paga al inicio de su acuerdo. Ayuda a confirmar su compromiso y es parte del costo total, no una tarifa adicional. Solo verá la página de pago después de que su oferta haya sido aceptada por el proveedor de financiación.",
  due_today: "Vence hoy",
  select_upfront_payment: "Seleccionar pago inicial",
  delete_item: "Eliminar artículo",
  deleting_item: "Eliminando artículo...",
  financing_amount: "Cantidad de financiación",
  upfront_payment_required: "Pago inicial requerido",
  complete_upfront_payment_to_finalize: "Complete el pago inicial para finalizar la financiación",
  financing_approved: "Financiación aprobada",
  payment_breakdown: "Desglose de pagos",
  total_order_value: "Valor total del pedido",
  secure_payment_notice: "Aviso de pago seguro",
  via_financing_provider: "Financiado a través de proveedor de financiación",
  submitting: "Enviando",
  complete: "Completo",
  your_financing_offer: "Su oferta de financiación",
  your_leasing_offer: "Su oferta de renting",
  please_provide_banking_info: "Por favor, proporcione la información bancaria",
  complete_your: "Complete su",
  thanks_for_your_application: "Gracias por su solicitud",
  you_will_hear_from_us_very_soon: "Le oiremos pronto",
  financing_details: "Detalles de Financiación",
  payment_amount: "Monto del Pago",
  payment_frequency: "Frecuencia",
  number_of_payments: "Número de Pagos",
  total_price: "Precio Total",
  first_payment_date: "Fecha del Primer Pago",
  lender: "Prestamista",
  loading_offer_details: "Cargando detalles de la oferta...",
  includes_device_lease_and_subscriptions: "Incluye alquiler de dispositivo y suscripciones",

  // TerraceFinance related translations
  residential_information: "Información Residencial",
  type_of_residence: "Tipo de Residencia",
  select_residence_type: "Seleccionar tipo de residencia",
  years_at_residence: "Años en Residencia Actual",
  identification_information: "Información de Identificación",
  document_type: "Tipo de Documento",
  select_document_type: "Seleccionar tipo de documento",
  document_number: "Número de Documento",
  identification_expiration_date: "Fecha de Vencimiento de Identificación",
  identification_issued_date: "Fecha de Emisión de Identificación",
  resident_since: "Residente Desde",
  card_expiration: "Vencimiento de Tarjeta",
  uscis_number: "Número USCIS",
  
  // Validation messages
  document_type_required: "El tipo de documento es obligatorio",
  document_number_required: "El número de documento es obligatorio",
  identification_expiration_date_required: "La fecha de vencimiento de identificación es obligatoria",
  identification_issued_date_required: "La fecha de emisión de identificación es obligatoria",
  resident_since_required: "La fecha de residencia es obligatoria",
  card_expiration_required: "La fecha de vencimiento de tarjeta es obligatoria",
  uscis_number_required: "El número USCIS es obligatorio",
  
  // Additional financing field translations
  employment_information: "Información de Empleo",
  
  // Type of Residency (corrected field name)
  type_of_residency: "Tipo de Residencia",
  type_of_residency_required: "El tipo de residencia es obligatorio",
  select_residency_type: "Seleccionar tipo de residencia",
  
  // Time at Current Residence
  time_at_current_residence: "Tiempo en Residencia Actual",
  time_at_current_residence_required: "El tiempo en residencia actual es obligatorio",
  
  // Housing Type
  housing_type: "Tipo de Vivienda",
  housing_type_required: "El tipo de vivienda es obligatorio",
  select_housing_type: "Seleccionar tipo de vivienda",
  
  // Employment Type
  employment_type: "Tipo de Empleo",
  employment_type_required: "El tipo de empleo es obligatorio",
  select_employment_type: "Seleccionar tipo de empleo",
  
  // Employment Name
  employment_name: "Nombre de Empresa/Empleador",
  employment_name_required: "El nombre del empleador es obligatorio",
  
  // Job Title
  job_title: "Título del Trabajo",
  job_title_required: "El título del trabajo es obligatorio",
  
  // Experience
  experience: "Experiencia",
  experience_required: "La experiencia es obligatoria",
  
  // Validation error messages
  expiration_date_not_before_today: "La fecha de vencimiento no puede ser anterior a hoy",
  issued_date_not_after_today: "La fecha de emisión no puede ser posterior a hoy",
  invalid_gross_income: "Formato de ingreso bruto inválido",
  invalid_net_income: "Formato de ingreso neto inválido",
  invalid_last_pay_day: "Formato de último día de pago inválido",
  invalid_next_pay_day: "Formato de próximo día de pago inválido",
  years_positive: "Los años deben ser un número positivo",
  years_must_be_number: "Los años deben ser un número",
  
  // Tooltip texts for new fields
  tooltip_document_number: "Ingrese su número de documento como aparece en su identificación",
  tooltip_resident_since: "Fecha desde que se convirtió en residente de EE.UU.",
  tooltip_card_expiration: "Fecha de vencimiento en su tarjeta de registro de extranjero",
  tooltip_uscis_number: "Su número de registro USCIS",
  
  // Error handling for specific conditions
  error_calculating_taxes: "Error al calcular impuestos",
  error: "Error",
  
  // Additional validation messages for time/experience fields
  time_unit_required: "La unidad de tiempo es obligatoria",
  experience_unit_required: "La unidad de experiencia es obligatoria",
  time_must_be_positive: "El tiempo debe ser al menos 1",
  time_must_be_whole_number: "El tiempo debe ser un número entero",
  experience_must_be_positive: "La experiencia debe ser positiva",
  experience_must_be_whole_number: "La experiencia debe ser un número entero",
  identification_issued_date_required: "La fecha de emisión de identificación es obligatoria",
  type_of_residence_required: "El tipo de residencia es obligatorio",
  years_at_residence_required: "Los años de residencia son obligatorios",
  manufacturer_name_required: "El nombre del fabricante es obligatorio",
  model_required: "El modelo es obligatorio",
  condition_required: "La condición es obligatoria",
  serial_number_required: "El número de serie es obligatorio",
  resident_since_required: "La fecha de inicio de residencia es obligatoria",
  card_expiration_required: "La fecha de vencimiento de la tarjeta es obligatoria",
  uscis_number_required: "El número USCIS es obligatorio",
  expiration_date_not_before_today: "La fecha de vencimiento no puede ser anterior a hoy",
  issued_date_not_after_today: "La fecha de emisión no puede ser posterior a hoy",
  invalid_gross_income: "Los ingresos brutos deben ser un número positivo",
  invalid_net_income: "Los ingresos netos deben ser un número positivo",

  // Tooltips
  tooltip_document_type: "La Licencia de Conducir es actualmente la única forma aceptada de identificación",
  tooltip_document_number: "Ingrese su número de licencia de conducir (4-20 caracteres alfanuméricos). Ejemplos: A1234567 (CA), 12345678 (TX), F123456789012 (FL)",
  tooltip_identification_expiration: "Cuando vence su documento de identificación",
  tooltip_identification_issued: "Cuando se emitió su documento de identificación",
  tooltip_type_of_residence: "Su situación de vivienda actual",
  tooltip_years_at_residence: "Cuánto tiempo ha vivido en la dirección actual",
  tooltip_manufacturer_name: "Nombre del fabricante del producto",
  tooltip_model: "Nombre/número del modelo del producto",
  tooltip_condition: "Condición actual del producto",
  tooltip_serial_number: "Número de serie del producto",
  tooltip_resident_since: "Desde cuándo es residente",
  tooltip_card_expiration: "Cuando vence su tarjeta",
  tooltip_uscis_number: "Su número de registro USCIS",
  years_must_be_number: "Los años deben ser un número válido",

  // Enhanced form field labels
  authorized_contact_person: "Persona de Contacto Autorizada",
  business_tax_id: "CIF / Número de Identificación Fiscal",
  housing_ownership: "¿Es propietario o alquila su vivienda?",
  dwelling_type: "¿En qué tipo de vivienda vive?",
  how_long_current_address: "¿Cuánto tiempo lleva viviendo en su dirección actual?",
  monthly_rent_mortgage: "Pago Mensual de Alquiler/Hipoteca",
  monthly_rent_mortgage_required: "El pago mensual de alquiler/hipoteca es obligatorio",
  
  // ✅ NEW: ID State of Issuance translations
  id_state_of_issuance: "Estado",
  id_state_of_issuance_required: "El estado donde se emitió su ID es obligatorio",
  select_id_state: "Estado donde se emitió su ID",
  tooltip_id_state_selection: "Seleccione el estado donde se emitió su documento de identidad (puede ser diferente de su dirección actual)",

  // ✅ NEW: Citizenship Status translations
  citizenship_status: "Estado de Ciudadanía",
  citizenship_status_required: "El estado de ciudadanía es obligatorio",
  select_citizenship_status: "Seleccione su estado de ciudadanía",
  tooltip_citizenship_status: "Seleccione su estado de ciudadanía o residencia actual en los Estados Unidos",
  
  employment_status: "¿Cuál es su situación laboral?",
  employer_or_income_source: "Empresa o Fuente de Ingresos",
  job_title_or_position: "Cargo o Posición",
  time_at_current_job: "¿Cuánto tiempo lleva en su trabajo/ingresos actuales?",
  monthly_income_before_taxes: "Ingresos Mensuales (Antes de Impuestos)",
  monthly_take_home_pay: "Salario Neto Mensual (Después de Impuestos)",
  how_often_paid: "¿Con qué frecuencia le pagan?",
  date_of_most_recent_paycheck: "Fecha de Su Última Nómina",
  date_of_next_expected_paycheck: "Fecha de Su Próxima Nómina Esperada",
  government_id_type: "¿Qué tipo de identificación gubernamental tiene?",

  // Enhanced tooltip translations
  tooltip_authorized_contact: "El nombre completo de la persona autorizada para tomar decisiones y firmar documentos para esta empresa",
  tooltip_business_tax_id: "El número oficial de identificación fiscal de su empresa (CIF en España, EIN en EE.UU., etc.)",
  tooltip_housing_ownership: "Seleccione si es propietario de su vivienda, la alquila, o tiene otro acuerdo (ej: viviendo con familia)",
  tooltip_dwelling_type: "Seleccione el tipo de edificio o vivienda en la que vive (apartamento, casa, suite, etc.)",
  tooltip_time_at_current_address: "Introduzca cuánto tiempo lleva viviendo en su dirección actual",
  tooltip_time_unit: "Seleccione si contar en meses o años",
  tooltip_rent_mortgage: "Introduzca el importe de su alquiler o hipoteca mensual",
  tooltip_employment_status: "Seleccione su situación laboral actual: Empleado (trabaja para una empresa), Autónomo (negocio propio), o Beneficiario (recibiendo beneficios del gobierno)",
  tooltip_employer_income_source: "Introduzca el nombre de su empleador, empresa, o fuente de ingresos (ej: nombre de empresa, 'Seguridad Social', 'Desempleo')",
  tooltip_job_title: "Introduzca su cargo, posición o rol (ej: Director, Vendedor, Profesor, Autónomo)",
  tooltip_experience_time: "Introduzca cuánto tiempo lleva en su trabajo actual o recibiendo sus ingresos actuales",

  // Credit check disclaimer messages
  checking_eligibility_wont_affect_credit: "Verificar su elegibilidad no afectará su crédito",
  soft_credit_check_no_impact: "Solo verificación suave de crédito • Sin impacto en su puntaje crediticio",

  // Summary section labels
  monthly_commitment: "Compromiso Mensual",
  you_will_pay_today: "Pagarás hoy",
  total_today: "Total hoy",
  
  // Cart operation messages
  success: "Éxito",
  removed_from_cart: "eliminado del carrito",
  cart_updated: "Carrito actualizado correctamente",
  product_removed_from_cart: "Producto eliminado del carrito",
  deleting_item: "Eliminando artículo...",
  delete_item: "Eliminar artículo",
  total_cost: "Costo total",
  'Loading cart data': "Cargando datos del carrito",
  select_date: "Por favor seleccione una fecha",
  hide_details: "Ocultar detalles",
  order_Summary: "Resumen de la orden",
  
  // Cart discount translations
  cart_discount_applied: "¡Descuento del Carrito Aplicado!",
  discount_applied_to_cart: "descuento aplicado a tu carrito",
  item_discount_applied: "¡Descuento del Artículo Aplicado!",
  discount_applied_to_item: "descuento aplicado a este artículo",
  qty: "Cantidad",
  est: "Est",
  down_payment: "Pago inicial",
  learn_more_about_financing: "Más información sobre financiación",
  financing_desclaimer: "*Los términos pueden variar según la aprobación crediticia y las tasas disponibles en el momento de la aplicación. No todos los solicitantes calificarán.",
  order_submitted: "Pedido Enviado",
  manual_processing_message: "Hemos recibido su pedido y lo procesaremos manualmente. Nuestro equipo se pondrá en contacto con usted en breve para completar el proceso de pago.",
  manual_processing_contact: "Si tiene alguna pregunta sobre su pedido, por favor contacte a nuestro equipo de atención al cliente.",
  canary_islands_manual_review: "Su pedido ha sido enviado para revisión. Los pedidos a las Islas Canarias requieren verificación adicional. Nos pondremos en contacto en las próximas 24 horas.",
  manual_review_info: "Nuestro equipo revisará su pedido y le contactará en 1 día hábil para finalizar los detalles.",
  manual_review_timeline: "El procesamiento normalmente toma 24 horas durante días hábiles.",
  order_id: "ID del Pedido",
  questions_contact: "Si tiene alguna pregunta, por favor contáctenos en",
  autonomus_community: "Comunidad Autónoma",
  b2b_renting_contact_title: "¿Preguntas sobre Renting B2B?",
  b2b_renting_contact_message: "Si tiene alguna duda o pregunta sobre el servicio de Renting B2B, por favor llame al",
  b2b_renting_phone: "+34678438486",
  total_monthly_commitment: "Compromiso Mensual Total",
  sales_tax: "Impuesto de Ventas",
  checkout_already_used: "Checkout Ya Utilizado",
  checkout_already_used_message: "Esta sesión de checkout ya ha sido utilizada o completada. Por favor, inicie un nuevo checkout para continuar.",
  tax_id_vat_number: "Número de identificación fiscal / NIF",
  companyName: "Nombre de la empresa"
};
